import './custom.css';

import axios from 'axios';
import { useAtom } from 'jotai';
import React, { FunctionComponent } from 'react';
import { Redirect, Route } from 'react-router';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { ErrorPage } from './components/ErrorPage';
import { Home } from './components/Home';
import { Layout } from './components/Layout';
import { Login } from './components/Login';
import { ResetPassword } from './components/ResetPassword';
import { authTokenAtom, currentUserAtom } from './utils/AtomConfig';
import { MdiService } from './utils/MdiService';

export const App: FunctionComponent = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#003591',
      },
    },
  });

  const mdiService = MdiService.Instance;
  const [authToken, setAuthToken] = useAtom(authTokenAtom);
  const [currentUser, setCurrentUser] = useAtom(currentUserAtom);

  // Setup auth bearer for axios if current user is authenticated
  if (authToken) {
    axios.defaults.headers.common = { Authorization: authToken };

    // Verify auth token
    mdiService
      .VerifyToken()
      .then((isVerified) => {
        if (!isVerified) {
          // Reset token cache
          setAuthToken('');
          return;
        }

        // Get current user data if it's empty
        if (currentUser === null) {
          // Get user data
          mdiService.GetUser().then(user => {
            setCurrentUser(user);
          });
        }
      })
      .catch(() => {
        // Reset token cache
        setAuthToken('');
      });
  }

  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Route exact path='/login' component={Login}></Route>
        <Route exact path='/reset/password' component={ResetPassword}></Route>
        <Route exact path='/error' component={ErrorPage}></Route>
        <Route exact path='/'>
          {authToken && <Home />}
          {!authToken && <Redirect to='/login' />}
        </Route>
        <Route exact path='/login'>
          {authToken && <Redirect to='/' />}
          {!authToken && <Login />}
        </Route>
        <Route exact path='/reset/password' component={ResetPassword}></Route>
      </Layout>
    </ThemeProvider>
  );
};
